<template>
  <v-container class="fill-height auth-page" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <AuthBrandHeader />

        <v-card class="auth-card" flat>
          <v-card-text class="pa-6">
            <template v-if="!passwordReset">
              <h1 class="auth-heading">Choose a new password</h1>
              <p class="auth-subtext">Must be at least 6 characters.</p>

              <v-form
                ref="form"
                v-model="valid"
                @submit.prevent="resetPassword"
              >
                <v-text-field
                  v-model="password"
                  :rules="passwordRules"
                  label="New password"
                  name="password"
                  prepend-icon="mdi-lock"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                  outlined
                  dense
                  required
                ></v-text-field>

                <v-text-field
                  v-model="passwordConfirm"
                  :rules="passwordConfirmRules"
                  label="Confirm new password"
                  name="passwordConfirm"
                  prepend-icon="mdi-lock-check"
                  :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPasswordConfirm ? 'text' : 'password'"
                  @click:append="showPasswordConfirm = !showPasswordConfirm"
                  outlined
                  dense
                  required
                ></v-text-field>

                <v-btn
                  class="auth-submit-btn mt-2"
                  type="submit"
                  block
                  large
                  :disabled="!valid || loading"
                  :loading="loading"
                >
                  Reset password
                </v-btn>
              </v-form>
            </template>

            <template v-else>
              <div class="text-center py-4">
                <v-icon color="success" size="56">mdi-check-circle</v-icon>
                <h1 class="auth-heading mt-4" style="text-align: center">
                  Password updated
                </h1>
                <p class="auth-subtext" style="text-align: center">
                  Your password has been reset. Sign in again. Other sessions and API keys must also be renewed.
                </p>
                <v-btn class="auth-submit-btn mt-2" large to="/login">
                  Go to login
                </v-btn>
              </div>
            </template>
          </v-card-text>

          <template v-if="!passwordReset">
            <v-divider></v-divider>
            <v-card-text class="auth-aux-line">
              Remembered your password?
              <router-link to="/login" class="auth-text-link">
                Back to login
              </router-link>
            </v-card-text>
          </template>
        </v-card>

        <div class="auth-footer-links">
          <a :href="landingUrl" target="_blank" rel="noopener"
            >About {{ $config.productName }}</a
          >
          <span class="auth-footer-sep">·</span>
          <a :href="'mailto:' + $config.SUPPORT_EMAIL">Support</a>
        </div>

        <!-- Error Alert -->
        <v-alert
          v-if="error"
          type="error"
          dismissible
          class="mt-4"
          @input="clearError"
        >
          {{ error }}
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AuthBrandHeader from "../components/AuthBrandHeader.vue";

export default {
  name: "ResetPasswordView",
  components: {
    AuthBrandHeader
  },
  data() {
    return {
      valid: false,
      password: "",
      passwordConfirm: "",
      showPassword: false,
      showPasswordConfirm: false,
      passwordReset: false,
      token: "",
      passwordRules: [
        v => !!v || "Password is required",
        v => v.length >= 6 || "Password must be at least 6 characters"
      ]
    };
  },
  computed: {
    ...mapGetters(["loading", "error"]),
    landingUrl() {
      return process.env.VUE_APP_LANDING_PAGE_URL || "https://multisaas.com";
    },
    passwordConfirmRules() {
      return [
        v => !!v || "Password confirmation is required",
        v => v === this.password || "Passwords do not match"
      ];
    }
  },
  created() {
    // Get token from route params
    this.token = this.$route.params.token;

    if (!this.token) {
      this.$router.push("/forgot-password");
    }
  },
  methods: {
    async resetPassword() {
      if (this.$refs.form.validate()) {
        try {
          await this.$store.dispatch("resetPassword", {
            token: this.token,
            password: this.password,
            passwordConfirm: this.passwordConfirm
          });

          this.$store.commit("LOGOUT");
          this.passwordReset = true;
        } catch (error) {
          // Error is handled by the store
          console.error("Password reset failed:", error);
        }
      }
    },
    clearError() {
      this.$store.commit("SET_ERROR", null);
    }
  }
};
</script>
